/**
 * Greeting generation mode constants — keep aligned with
 * `ScheduledSmiles.Api.Constants.GreetingGenerationModes`.
 */
export const GreetingGenerationModes = {
  ECard: 'ecard',
  MailedCard: 'mailed',
} as const;

/** Request parameters for generating a greeting. */
export interface GenerateGreetingRequest {
  contactId: number;
  eventTypeId: number;
  /** Required for e-card mode; omitted for mailed-card mode. */
  cardTemplateId?: number;
  /** `ecard` (default) or `mailed` for physical card message text. */
  mode?: typeof GreetingGenerationModes.ECard | typeof GreetingGenerationModes.MailedCard;
  /** Per-panel target when mode is mailed (legacy; optional). */
  mailedCardPanelNumber?: number;
  /** Max body length for mailed-card mode (defaults server-side from Cardly config). */
  maxBodyLength?: number;
  eventDate?: string;
  /** When present, the API treats the call as Rewrite rather than Suggest. */
  existingGreetingBody?: string;
  /** Per-call Tone override; does not mutate ContactEventType.preferredTone. */
  tone?: string;
  /** Session rewrite instructions or refinement-chip label (rewrite only). */
  instructions?: string;
}
